<template>
  <div class="style-page">
    <h1 class="style__header">Typography</h1>
    <section>
      <template v-for="(t, index) in typography">
        <div class="style__typo" :key="index">
          <component :ref="t.dom" :is="t.dom" :href="t.dom === 'a'">
            {{ t.label }}
          </component>
        </div>
      </template>
    </section>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Typography style guide page
 * ==================================================================================
 **/

export default {
  data: function() {
    return {
      typography: [
        { dom: 'h1', label: 'Heading 1' },
        { dom: 'h2', label: 'Heading 2' },
        { dom: 'h3', label: 'Heading 3' },
        { dom: 'h4', label: 'Heading 4' },
        { dom: 'h5', label: 'Heading 5' },
        { dom: 'h6', label: 'Heading 6' },
        { dom: 'p', label: 'Paragraph' },
        { dom: 'label', label: 'Label' },
        { dom: 'a', label: 'Anchor' }
      ]
    }
  },

  mounted: function() {
    this.initTypoStyles()
  },

  methods: {
    /**
     * Display CSS styles on typography elements
     * below each item
     */
    initTypoStyles() {
      const typos = document.querySelectorAll('.style__typo > *')
      typos.forEach(elem => {
        const styles = window.getComputedStyle(elem)
        const css = document.createElement('label')

        css.innerHTML =
          'Family: ' +
          styles.getPropertyValue('font-family') +
          ' | Size: ' +
          styles.getPropertyValue('font-size') +
          ' | Weight: ' +
          styles.getPropertyValue('font-weight')

        elem.parentNode.append(css)
      })
    }
  }
}
</script>
<style scoped lang="scss">
.style-page /deep/ {
  text-align: center;

  .style__header {
    display: inline-block;
    font-size: 20px;
    line-height: 20px;
    font-weight: bold;
    text-transform: uppercase;
    padding-bottom: 5px;
  }

  section {
    margin-bottom: 50px;

    .style__typo {
      margin: 20px 0;

      > *:nth-child(1) {
        display: block;
        margin: 0;
      }

      > label:nth-child(2) {
        font-family: 'Arial';
        font-size: 9px;
      }
    }
  }
}
</style>
